// Mirrors REOPEN_WINDOW_MS in api/constants/railcarStatus.js. Kept in sync by hand; the value is
// shown to operators on the Inventory Locations page, so a change here needs one there too.
export const CORRECTION_WINDOW_HOURS = 72
